import React from 'react'

import { reverse } from 'named-urls'

import { Table, TableBody, TableCell, TableRow, Box } from '@material-ui/core'

import { routes } from 'routes'
import { GenerateSkeleton } from 'components/Table'
import { LogIconButton } from 'components/Logs'
import constants from './../../../../../../constants'

const SettingsWebhookTable = ({ isLoading, settings }) => {
  return isLoading ? (
    <Table>
      <TableBody>
        <GenerateSkeleton rows={2} cols={2} />
      </TableBody>
    </Table>
  ) : (
    <Table>
      <TableBody>
        <TableRow hover>
          <TableCell width="40%">
            Notificação de alterações e criação de faturas
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {(settings.urlNotificationDefaultInvoices &&
                settings.urlNotificationDefaultInvoices.value) ||
                'Não configurado'}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.URL_NOTIFICATION_DEFAULT_INVOICES,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
        <TableRow hover>
          <TableCell>
            Notificação de alterações e criação de assinaturas
          </TableCell>
          <TableCell>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              {(settings.urlNotificationDefaultInvoices &&
                settings.urlNotificationDefaultContract.value) ||
                'Não configurado'}
              <LogIconButton
                to={reverse(routes.settings.logs, {
                  settingId:
                    constants.settings.URL_NOTIFICATION_DEFAULT_CONTRACTS,
                })}
              />
            </Box>
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

export default SettingsWebhookTable
